// extracted by mini-css-extract-plugin
export default {"full-screen":"FullScreen_full-screen__Q0kCt"};